import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  SecurityPolicy,
  API_PATH_SECURITY_POLICY,
} from './securityPolicy.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getSecurityPolicy(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<SecurityPolicy>> {
  return http.get(`${API_PATH_SECURITY_POLICY}`);
}

export function updateSecurityPolicy(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SecurityPolicy[]>,
): AxiosPromise<ServerResponse<SecurityPolicy[]>> {
  return http.put(`${API_PATH_SECURITY_POLICY}`, body);
}
